import { coerceMessage, errorToObject, safeStringify } from '../util/serialize.js';

export interface FormattedConsoleArgs {
  message: string;
  args?: unknown[];
  errorName?: string;
  errorMessage?: string;
  stack?: string;
}

export function formatConsoleArgs(
  rawArgs: unknown[],
  opts: { maxMessageLength: number; maxArgsBytes: number },
): FormattedConsoleArgs {
  if (rawArgs.length === 0) {
    return { message: '' };
  }
  const first = rawArgs[0];
  const rest = rawArgs.slice(1);

  const out: FormattedConsoleArgs = {
    message: coerceMessage(first, opts.maxMessageLength),
  };

  if (first instanceof Error) {
    const e = errorToObject(first);
    if (e.name) out.errorName = e.name;
    if (e.message) out.errorMessage = e.message;
    if (e.stack) out.stack = e.stack;
  }

  if (rest.length > 0) {
    out.args = rest.map((a) => {
      if (a instanceof Error) {
        const e = errorToObject(a);
        return e;
      }
      try {
        return JSON.parse(safeStringify(a, opts.maxArgsBytes));
      } catch {
        return safeStringify(a, opts.maxArgsBytes);
      }
    });
  }

  return out;
}
